import Navbar from "./components/Navbar";
import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import Home from "./screen/Home";
import "./App.css";
import ContactUs from "./screen/ContactUs";
import AboutUs from "./screen/AboutUs";
import itServices from "./screen/ITServices";
import projManagement from "./screen/ProjectManagement";
import globalLogistics from "./screen/GlobalLogistics";
import fieldDispatch from "./screen/FieldDispatch";
import ProjectManagement from "./screen/ProjectManagement";
import ItServices from "./screen/ITServices";
import GlobalLogistics from "./screen/GlobalLogistics";
import FieldDispatch from "./screen/FieldDispatch";
function App() {
  return (
    <>
      <HashRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/AboutUs"
            element={<AboutUs /> || <div>Failed to load AboutUs</div>}
          />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/services/itServices" element={<ItServices />} />
          <Route
            path="/services/projManagement"
            element={<ProjectManagement />}
          />
          <Route
            path="/services/globalLogistics"
            element={<GlobalLogistics />}
          />
          <Route path="/services/fieldDispatch" element={<FieldDispatch />} />
        </Routes>
      </HashRouter>
    </>
  );
}

export default App;
